// Utility to find the most recent valid Date from multiple arrays of date strings
export const findMostRecentDoneAt = (
  ...dateStringLists: string[][]
): Date | null => {
  // 1. Merge all lists into a single array of date strings
  const allDateStrings = dateStringLists.flat();

  // 2. Use reduce to find the most recent valid date
  const mostRecentDate = allDateStrings.reduce(
    (latestDate: Date | null, dateString) => {
      // Skip falsy values like empty strings/null/undefined
      if (!dateString) {
        return latestDate;
      }

      const currentDate = new Date(dateString);

      // Guard against invalid date strings
      if (isNaN(currentDate.getTime())) {
        return latestDate;
      }

      // If no latest yet, or current is newer, take current
      if (!latestDate || currentDate > latestDate) {
        return currentDate;
      }

      return latestDate;
    },
    null
  );

  return mostRecentDate;
};
